<p-dropdown
  [options]="statusFilters"
  styleClass="inputfield"
  class="dropdown-custom"
  appendTo="body"
  [showClear]="showClear"
  name="statusFilters"
  [(ngModel)]="statusFilter"
  (onChange)="onStatusChange($event)"
  optionLabel="label"
  optionValue="value"
  placeholder="{{'common.all' | translate}}">

  <ng-template pTemplate="selectedItem">
    @if (statusFilter) {
      <div>
        <div class="status-customer-{{ transform(statusFilter) }}">
          <span><em class="fa fa-circle fa-5"></em></span>
          @if (showSelectedText) {
            <span>{{ ('status.' + statusFilter.toLowerCase()) | translate }}</span>
          }
        </div>
      </div>
    }

  </ng-template>

  <ng-template let-status pTemplate="item">
    <div class="status-customer-{{ transform(status.value) }}">
      @if (status.value !== '') {
        <span>
          <em class="fa {{ status.value === 'APPROVED' ? 'fa-circle-o' : 'fa-circle' }} status-{{ transform(status.value) }}" style="margin-right: 5px;"></em>
        </span>
      }
      <span>{{ status.label | translate}}</span>
    </div>
  </ng-template>
</p-dropdown>
